// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5b9c31f3","455":"5ff418ca","977":"5110f9ac"}[chunkId] + ".chunk.js";
};